import React from 'react'
import { SmartTooltip } from '../../../../../../../components/SmartTooltip/SmartTooltip'
import { OverpaymentHistoryItem } from '../../core/response.types'
import { OverpaymentHistoryTable } from '../OverpaymentHistoryTable/OverpaymentHistoryTable'

interface Props {
  history: OverpaymentHistoryItem[] | undefined
  disabled: boolean
  onClick: () => void
}

const card: React.CSSProperties = {
  backgroundColor: 'var(--bs-body-bg)',
  color: 'var(--bs-body-color)',
  border: '1px solid var(--bs-border-color)',
  borderRadius: 6,
  boxShadow: '0 2px 8px rgba(0,0,0,.15)',
  padding: '8px 12px',
}

export const OverpaymentButton: React.FC<Props> = ({ history, disabled, onClick }) => {
  const previous = history ?? []
  const button = (
    <button
      type='button'
      className='btn btn-sm btn-light-warning'
      disabled={disabled}
      onClick={onClick}
    >
      {previous.length > 0 ? 'Переоплатить повторно' : 'Переоплатить'}
    </button>
  )

  if (previous.length === 0) return button

  // A disabled button fires no mouse events, so the tooltip hangs on a wrapper.
  return (
    <SmartTooltip
      bare
      content={
        <div style={card}>
          <div style={{ fontWeight: 600, fontSize: 12, marginBottom: 6 }}>
            Переоплат по депозиту: {previous.length}
          </div>
          <OverpaymentHistoryTable items={previous} />
        </div>
      }
    >
      <span className='d-inline-block'>{button}</span>
    </SmartTooltip>
  )
}
